module.exports = __webpack_public_path__ + "img/1078098622.2b00414b.jpg";